module.exports = __webpack_public_path__ + "static/media/t_big_02.4c905cbd.png";